const _ = require('lodash');

module.exports.doesUserCustomRoleHaveAccessToFeature = (customAccess, accessNeededForFeature, doesRequireAllUrls = false) => {
    if (!customAccess) {
        return true;
    }

    return _.reduce(accessNeededForFeature, (doesHaveAccessToFeature, serviceAccessNeededForFeature, serviceArnNeededForFeature) => {
        const customAccessUrls = _.get(customAccess, serviceArnNeededForFeature);

        if (_.isEmpty(customAccessUrls)) {
            return false;
        }

        const featureUrlsRoleHasAccessTo = _.intersection(serviceAccessNeededForFeature, customAccessUrls);

        if (_.isEmpty(featureUrlsRoleHasAccessTo)) {
            return false;
        }

        if (doesRequireAllUrls && doesHaveAccessToFeature) {
            return _.size(featureUrlsRoleHasAccessTo) === _.size(serviceAccessNeededForFeature);
        } else if (!doesHaveAccessToFeature) {
            return !_.isEmpty(featureUrlsRoleHasAccessTo);
        } else {
            return doesHaveAccessToFeature;
        }
    }, true);
};
